import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { DpModuleService } from "src/app/dp-module/dp-module.service";
import { distinct, from, tap } from "rxjs";
import { InsiderServiceService } from "src/app/insider/insider-service.service";
import { PitComplianceService } from "../../pit-compliance.service";
import { ToastrService } from "ngx-toastr";
import { CustomerService } from "src/app/customer/customer.service";
import { CompanyService } from "src/app/master/company/company.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: "app-add-trading-window-closure",
  templateUrl: "./add-trading-window-closure.component.html",
  styleUrls: ["./add-trading-window-closure.component.scss"],
})
export class AddTradingWindowClosureComponent implements OnInit {
  submitted: boolean = false;
  isLoading = false;
  button = "Save";
  twcCreateForm: FormGroup;
  htmlContent = "";
  selected_sender: any = [];
  selected_receiver: any = [];
  selected_both: any = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2: IDropdownSettings;
  selectedItems = [];
  listDpModule: any;
  senderList: any = [];
  selectedSenderItems = [];
  selectedRecipentDpItems:any = [];
  recipientDpList: any = [];
  listinsider: any;
  recipentInsiderList: any = [];
  selectedRecipentInsiderItems = [];
  selectedRecipentbothItems = [];
  recipientBothList: any = [];
  recipientBothList1 = [];
  dropdownListRep: any = [];
  dropdownListInsider: any = [];
  dropdownListRepAll = [];
  selectedFile: any = [];
  pathImage: any[];
  selectedFileName: any[] = [];
  openTwcAttachment: boolean = false;
  tradingCompanyNameList: any;
  selectedtradingCompanyNameList = [];
  is_access_read = false;
  is_access_write = false;
  is_access_no = false;
  user_roles;
  companyApplication: any;
  //sooriyan
  flattenedRecipientDpList: any = [];
  panelOpen = false;

searchText = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private companyService: CompanyService,
    private customerService: CustomerService,
    private dpService: DpModuleService,
    private insiderService: InsiderServiceService,
    private toastr: ToastrService,
    private pitService: PitComplianceService,
    private sanitizer: DomSanitizer
  ) {}
  private dateRangeValidator: ValidatorFn = (): {
    [key: string]: any;
  } | null => {
    let invalid = false;
    const from =
      this.twcCreateForm && this.twcCreateForm.get("start_date")?.value;
    const to = this.twcCreateForm && this.twcCreateForm.get("end_date")?.value;

    if (from && to) {
      invalid = new Date(from).valueOf() > new Date(to).valueOf();
    }
    return invalid ? { invalidRange: { from, to } } : null;
  };
  ngOnInit(): void {
    let accessData: any = sessionStorage.getItem("model_access_controller");
    let accessModelController = JSON.parse(accessData);
    if (
      accessModelController.twcattachment_access == true ||
      accessModelController.twcattachment_access == 1
    ) {
      this.openTwcAttachment = true;
    } else {
      this.openTwcAttachment = false;
    }
    this.user_roles = JSON.parse(
      atob(sessionStorage.getItem("sdd_access_roles"))
    );
    if (this.user_roles.customer_read == "2") {
      this.is_access_write = true;
      this.is_access_read = true;
      this.is_access_no = true;
    } else if (this.user_roles.customer_read == "1") {
      this.is_access_write = false;
      this.is_access_read = true;
      this.is_access_no = true;
    }

    this.twcCreateForm = this.fb.group({
      start_date: new FormControl("", Validators.required),
      end_date: new FormControl("", [
        Validators.required,
        this.dateRangeValidator,
      ]),
      sender: new FormControl("", Validators.required),
      recipientvalue: new FormControl("Insider"),
      recipient: new FormControl("", Validators.required),
      tradingcompanyname: new FormControl(""),
      period: new FormControl(""),
      subject: new FormControl("", Validators.required),
      htmlcontents: new FormControl(""),
      agreement_attachment_file: new FormControl(),
      agreement_attachment: new FormControl(),
    });

    //multi select
  //    this.dropdownSettings = {
  //   singleSelection: false,
  //   idField: "item_id",
  //   textField: "item_text",
  //   selectAllText: "Select All",
  //   unSelectAllText: "UnSelect All",
  //   itemsShowLimit: 2,
  //   allowSearchFilter: true,
  //   defaultOpen: false,
  //   enableCheckAll: false,
  //   closeDropDownOnSelection: false,
  //   allowHtml: true, // ✅ enables HTML in text
  // };

//   this.dropdownSettings = {
//   singleSelection: false,
//   idField: "item_id",
//   textField: "item_text",
//   selectAllText: "Select All",
//   unSelectAllText: "UnSelect All",
//   itemsShowLimit: 2,
//   allowSearchFilter: true,
//   defaultOpen: false,
//   enableCheckAll: false,
//   closeDropDownOnSelection: false,
// };

this.dropdownSettings = {
  idField: 'item_id',
  textField: 'item_text',
  allowHtml: true,
  singleSelection: false,
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 2,
  allowSearchFilter: true,
  defaultOpen: false,

  // ✅ Custom function to tell the dropdown to trust your HTML
  customDisplayFn: (item: any) => {
    return item.item_text; // keep HTML as is, library will render HTML now
  },
};


    this.dropdownSettings1 = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
    };

    this.companyService.CompanyList(null).subscribe(
      (res) => {
        if (res.body["message"] == "Invalid User.") {
          this.router.navigate(["/auth/login"]);
        } else {
          let listCompany = res.body["data"];
          this.companyApplication = listCompany[0]?.customertype;
          console.log("companyApplication", this.companyApplication);
        }
      },
      (err) => {
        console.log(err);
      }
    );

    this.selectedItems = [];
    this.dropdownListRepAll = [];
    //DP Api Call
    this.dpService.dpModuleList(null).subscribe(
    (res) => {
      this.senderList = [];
      this.recipientDpList = [];

      this.listDpModule = res["data"];

      const insiderList = this.listDpModule.map(({ id, email }) => ({
        item_id: id,
        item_text: email,
        NestedArray: [],
      }));

      this.dropdownListRep = [];
      insiderList.forEach((result) => this.dropdownListRep.push(result));

      let dropdownListSender: any = [];
      let senderList = this.listDpModule.map((item) =>
        dropdownListSender.push(item.email)
      );

      from(dropdownListSender)
        .pipe(tap((item) => item), distinct((d) => d))
        .subscribe((r) => this.senderList.push(r));

      from(this.dropdownListRep)
        .pipe(tap((item) => item), distinct((d: any) => d.item_text))
        .subscribe((r) => this.recipientDpList.push(r));

      this.flattenDropdownList();
    },
    (err) => {
      console.log(err);
    }
  );

    //Insider Api
    this.insiderService.insiderList(null).subscribe(
      (res) => {
        this.recipentInsiderList = [];
        // this.selectedRecipentbothItems = []

        this.listinsider = res.data;
        // const recipentList2 = this.listinsider.map(res =>res.email);
        //   const recipentList3 = recipentList2.filter(result => result)
        const insiderList = this.listinsider.map(({ id, email }) => ({
          item_id: id,
          item_text: email,
        }));
        this.dropdownListInsider = [];
        insiderList.forEach((result) => this.dropdownListInsider.push(result));

        from(this.dropdownListInsider)
          .pipe(
            tap((item) => item),
            distinct((d: any) => d.item_text)
          )
          .subscribe((r) => this.recipentInsiderList.push(r));

        // this.selectedRecipentbothItems.push(this.recipentInsiderList);
        //Insider Both
        // this.recipentInsiderList.forEach(result =>this.dropdownListRepAll.push(result))
        // this.dropdownListRepAll.forEach((item, index) => item.item_id = index + 1);
        // from(this.dropdownListRepAll)
        // .pipe(
        //   tap(item => item),
        //   distinct(d => d.item_text)
        // )
        // .subscribe(r => this.recipientBothList.push(r));
      },
      (err) => {
        console.log(err);
      }
    );
    //Both Api

    this.pitService.dpInsiderrecipient(null).subscribe(
      (res) => {
        const bothListEmail = res.data;

        const bothList = bothListEmail.map(({ dpemail }) => ({
          item_text: dpemail,
        }));
        bothList.forEach((item, index) => (item.item_id = index + 1));

        this.recipientBothList = [];
        from(bothList)
          .pipe(
            tap((item) => item),
            distinct((d) => d)
          )
          .subscribe((r) => this.recipientBothList.push(r));
      },
      (err) => {
        console.log(err);
      }
    );
    //  this.selectedRecipentbothItems =  this.recipientBothList;
    this.selectedRecipentbothItems = [];
    this.onFileChanged(event);
  }
  //attachement file
  onFileChanged(event: any) {
    if (event?.target.files && event?.target.files[0]) {
      var filesAmount = event?.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        //this.selectedFileName.push(event?.target.files[i].name)
        this.selectedFileName.push(event?.target.files[i].name);
        //this.fileList.push(event?.target.files[i].name);

        reader.onload = (event: any) => {
          this.selectedFile?.push(event.target.result);
        };

        reader.readAsDataURL(event.target.files[i]);
      }
    }
    //customer
    this.customerService.customerTradingAllowedList(null).subscribe(
      (res) => {
        let allowedCompanyList = [];
        let allowedCompanyLists = [];
        let listcompanyList = res.body["data"];

        let dropdownListCompany: any = [];
        const tradingCompanyList = listcompanyList?.map(
          ({ id, company_name }) => ({ item_id: id, item_text: company_name })
        );
        tradingCompanyList.forEach((result) =>
          dropdownListCompany.push(result)
        );
        this.tradingCompanyNameList = [];
        from(dropdownListCompany)
          .pipe(
            tap((item) => item),
            distinct((d) => d)
          )
          .subscribe((r) => this.tradingCompanyNameList.push(r));
        listcompanyList.map((item) => {
          // if(item.tradingpermission == 'Allowed'){
          //     allowedCompanyList.push(item);
          //     allowedCompanyList.map(item => allowedCompanyLists.push(item.company_name) )
          //     this.allowedCompanyList = [];
          //     from(allowedCompanyLists)
          //     .pipe(
          //       tap(item => item),
          //       distinct(d => d)
          //     )
          //     .subscribe(r => this.allowedCompanyList.push(r));
          //   }else{
          //   this.regstrictedCompanyList.push(item);
          // }
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.selectedFile?.splice(index, 1);
    // delete file from FileList
    this.selectedFileName?.splice(index, 1);
  }
  cancelTwcTemplate() {
    this.router.navigate(["/pit-compliance/list-twc"]);
    this.twcCreateForm.reset();
    this.submitted = false;
  }
  onSubmit() {
    this.submitted = true;
    const emptyFileds = Object.keys(this.twcCreateForm.controls).filter(
      (key) => this.twcCreateForm.controls[key].errors !== null
    );
    this.twcCreateForm.value.agreement_attachment = this.selectedFile;
    this.twcCreateForm.value.attachmentfilename = this.selectedFileName;
    console.log(this.twcCreateForm.value);

    if (this.twcCreateForm.status !== "INVALID") {
      this.isLoading = true;
      this.button = "Processing";
      // return
      this.pitService
        .tradingWindowClosureCreate(this.twcCreateForm.value)
        .subscribe((data) => {
          this.isLoading = false;
          this.button = "Save";
          this.toastr.success(
            "Trading Window Closure details created",
            "Success!"
          );
          this.router.navigate(["pit-compliance/list-twc"]);
        });
    } else if (emptyFileds.length > 1) {
      this.toastr.warning("Please fill all Mandatory fileds.");
      this.isLoading = false;
      this.button = "Save";
      return false;
    } else if (
      this.twcCreateForm.get("start_date")?.value >
      this.twcCreateForm.get("end_date")?.value
    ) {
      this.toastr.warning("Please add a valid from and To date.");
    } else {
      if (this.twcCreateForm.get("sender")?.value == "") {
        this.toastr.warning("Please fill the Sender Name.");
      } else if (this.twcCreateForm.get("recipient")?.value == "") {
        this.toastr.warning("Please fill the Recipient Name.");
      } else if (this.twcCreateForm.get("subject")?.value == "") {
        this.toastr.warning("Please fill the Subject.");
      } else if (this.twcCreateForm.get("start_date")?.value == "") {
        this.toastr.warning("Please fill the Start Date.");
      } else if (this.twcCreateForm.get("end_date")?.value == "") {
        this.toastr.warning("Please fill the End Date.");
      }
    }
  }

  //Angular Editor Setting
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    maxHeight: "auto",
    width: "auto",
    minWidth: "0",
    enableToolbar: true,
    showToolbar: true,
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    defaultFontSize: "",
    toolbarHiddenButtons: [[]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  // Multi Select
  onItemSelect(item: any, page) {
    if (page == "sender") {
      if (!this.selected_sender.includes(item)) {
        this.selected_sender.push(item);
      }
    } else if (page == "receiver") {
      if (!this.selected_receiver?.includes(item)) {
        this.selected_receiver.push(item);
      }
    } else if (page == "both") {
      if (!this.selected_both?.includes(item)) {
        this.selected_both.push(item);
      }
    }
  }

  // onItemDeSelect(item: any,page) {

  //   if(page == "sender"){
  //     if(this.selected_sender.includes(item)){
  //       this.selected_sender.splice(this.selected_sender.indexOf(item), 1);
  //     }
  //   }else if(page == "receiver"){
  //     if(this.selected_receiver.includes(item)){
  //       this.selected_receiver.splice(this.selected_receiver.indexOf(item), 1);
  //     }
  //   }else if(page == "both"){
  //     if(this.selected_both.includes(item)){
  //       this.selected_both.splice(this.selected_both.indexOf(item), 1);
  //     }
  //   }
  // }

//   onItemDeSelectDp(deselectedItem: any) {
//     const itemId = deselectedItem.item_id;

//     // if a child was deselected (e.g. "46_32"), do nothing special
//     if (String(itemId).includes("_")) {
//       return;
//     }

//     const dpId = itemId;

//     // Clear nested relatives from the main nested array
//     const dpObj = this.recipientDpList.find((d: any) => d.item_id === dpId);
//     if (dpObj) {
//       dpObj.NestedArray = [];
//     }

//     // Remove all child rows from flattened list
//     this.flattenedRecipientDpList = this.flattenedRecipientDpList.filter(
//       (it: any) => !String(it.item_id).startsWith(`${dpId}_`)
//     );
//     this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
//   (item: any) => !String(item.item_id).startsWith(`${dpId}_`)
// );
//     // Optionally ensure parent remains or is removed per your selection logic
//     // Rebuild flattened list also to keep order consistent
//     this.flattenDropdownList();
//   }

  

  onSelectAll(items: any, page) {
    if (page == "sender") {
      this.selected_sender = items;
    } else if (page == "receiver") {
      this.selected_receiver = items;
    } else if (page == "both") {
      this.selected_both = items;
    }
  }
  onDeSelectAll(items: any, page) {
    if (page == "sender") {
      this.selected_sender = [];
    } else if (page == "receiver") {
      this.selected_receiver = [];
    } else if (page == "both") {
      this.selected_both = [];
    }
  }
  onDropDownClose(item: any) {
    if (this.senderList.length > 1) {
    }
  }
  onFilterChange(item: any) {
    console.log(item);
  }
  closeDropdown(item) {
    if ((this.dropdownSettings["defaultOpen"] = false)) {
    }
    this.dropdownSettings["defaultOpen"] = false;

    // if (this.senderList.length>1) {
    //   const element = document.getElementsByClassName("dropdown-list");
    //   for(var e = 0; e < element.length; e++){
    //     var elt = element[e];
    //     elt.setAttribute("hidden", "");

    //   }
    //   const elementClass = document.querySelector(".dropdown-multiselect--active");

    //   elementClass?.classList.remove("dropdown-multiselect--active");
    // }
  }
  onmouseleave() {}
  blur() {}
  closeDropDownOnSelection() {}
  //select radio recipient button
  selectedButtonRep: string = "Insider";

  radioSelectRep(e: string): void {
    this.selectedButtonRep = e;
    if (this.selectedButtonRep == "Insider") {
      this.selectedRecipentDpItems = [];
      this.selectedRecipentbothItems = [];
    } else if (this.selectedButtonRep == "DP") {
      this.selectedRecipentInsiderItems = [];
      this.selectedRecipentbothItems = [];
    } else {
      this.selectedRecipentInsiderItems = [];
      this.selectedRecipentDpItems = [];
    }
  }

  isSelectedRep(name: string): boolean {
    if (!this.selectedButtonRep) {
      return false;
    }

    return this.selectedButtonRep === name;
  }
  //select radio recipient button

  //sooriyan
//   onItemSelectDp(selectedItem: any) {
//   const itemId = selectedItem.item_id;

//   // Skip if it's a relative
//   if (String(itemId).includes("_")) return;

//   const dpId = itemId;

//   const dpObj = this.recipientDpList.find((d: any) => d.item_id === dpId);
//   if (dpObj && dpObj.NestedArray && dpObj.NestedArray.length > 0) {
//     this.flattenDropdownList();
//     return;
//   }

//   this.insiderService.getImmediateRelatives(dpId).subscribe({
//     next: (res) => {
//       const relatives = res.map((r: any) => ({
//         item_id: `${dpId}_${r.imr_id}`,
//         item_text: r.relativeemail, // no arrow here
//         isRelative: true,
//       }));

//       if (dpObj) {
//         dpObj.NestedArray = relatives;
//       } else {
//         this.recipientDpList.push({
//           item_id: dpId,
//           item_text: selectedItem.item_text,
//           NestedArray: relatives,
//           isRelative: false,
//         });
//       }

//       this.flattenDropdownList();
//     },
//     error: (err) => console.error("Error loading relatives:", err),
//   });
// }

  onItemSelectDp(itemId: any) {
  // child click? skip API call
  if (String(itemId).includes('_')) return;

  const dpId = itemId;
  const dpObj = this.recipientDpList.find((d: any) => d.item_id === dpId);

  // avoid duplicate calls
  if (dpObj?.NestedArray?.length > 0) {
    this.flattenDropdownList();
    return;
  }

  // ✅ fetch immediate relatives
  this.insiderService.getImmediateRelatives(dpId).subscribe({
    next: (res) => {
      if (!Array.isArray(res)) return;

      const relatives = res
        .filter((r: any) => r.relativeemail)
        .map((r: any) => ({
          item_id: `${dpId}_${r.imr_id}`,
          item_text: r.relativeemail,
          isRelative: true
        }));

      // attach relatives
      if (dpObj) dpObj.NestedArray = relatives;
      else {
        this.recipientDpList.push({
          item_id: dpId,
          item_text: 'Unknown',
          NestedArray: relatives
        });
      }

      // rebuild flat list
      this.flattenDropdownList();
    },
    error: (err) => console.error('Error loading relatives:', err)
  });
}

onItemDeSelectDp(itemId: any) {
  // child item (relative)
  if (String(itemId).includes('_')) return;

  const dpId = itemId;

  // 1️⃣ remove children from selection
  this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
    (id: any) => !String(id).startsWith(`${dpId}_`)
  );

  // 2️⃣ clear nested list to collapse them
  const dpObj = this.recipientDpList.find((d: any) => d.item_id === dpId);
  if (dpObj) dpObj.NestedArray = [];

  // 3️⃣ rebuild UI list
  this.flattenDropdownList();
}


flattenDropdownList() {
  this.flattenedRecipientDpList = this.recipientDpList.flatMap((dp: any) => [
    {
      item_id: dp.item_id,
      item_text: dp.item_text,
      isRelative: false
    },
    ...(dp.NestedArray || []).map((rel: any) => ({
      item_id: rel.item_id,
      item_text: rel.item_text,
      isRelative: true
    }))
  ]);

  // trigger UI re-render
  this.flattenedRecipientDpList = [...this.flattenedRecipientDpList];
}



onPrimeDpSelect(event: any) {
  const selectedIds = event.value || [];

  // Normalize to strings for reliable checks
  const selectedIdStrings = selectedIds.map((id: any) => {
    // If id is an object with item_id property, use that
    if (id && typeof id === 'object' && id.item_id) return String(id.item_id);
    return String(id);
  });

  // Parents are ids that don't include an underscore
  const newParentIds = selectedIdStrings.filter(idStr => !idStr.includes('_'));

  // Load relatives for newly selected parents (only if not loaded)
  newParentIds.forEach(dpIdStr => {
    const dpObj = this.recipientDpList.find((d: any) => String(d.item_id) === dpIdStr);
    if (!dpObj) return;
    if (dpObj.NestedArray && dpObj.NestedArray.length) return; // already loaded
    console.log('dpObj',dpObj)
    this.insiderService.getImmediateRelatives(dpObj).subscribe({
      next: (res) => {
        const relatives = (res || [])
          .filter((r: any) => r.relativeemail)
          .map((r: any) => ({
            item_id: `${dpObj.item_id}_${r.imr_id}`,
            item_text: r.relativeemail,
            isRelative: true
          }));
        dpObj.NestedArray = relatives;
        this.flattenDropdownList();
      },
      error: (err) => console.error('Error loading relatives:', err)
    });
  });

  // Find unselected parents (parents that exist in recipientDpList but not selected now)
  const selectedParentIdsSet = new Set(selectedIdStrings.filter(s => !s.includes('_')));
  const unselectedParents = this.recipientDpList
    .map(d => String(d.item_id))
    .filter(pid => !selectedParentIdsSet.has(pid));

  if (unselectedParents.length) {
    // remove any child selections that belong to unselected parents
    this.selectedRecipentDpItems = (this.selectedRecipentDpItems || []).filter((id: any) => {
      const idStr = String(id);
      return !unselectedParents.some(parentId => idStr.startsWith(`${parentId}_`));
    });

    // collapse / clear children lists of unselected parents (optional)
    unselectedParents.forEach(pid => {
      const dp = this.recipientDpList.find(x => String(x.item_id) === pid);
      if (dp) dp.NestedArray = [];
    });

    this.flattenDropdownList();
  }
}

onItemClicked(item: any, event: MouseEvent) {
  event.stopPropagation(); // ✅ prevents panel close

  const id = String(item.item_id);

  if (id.includes('_')) {
    // Child (relative)
    if (this.selectedRecipentDpItems.includes(id)) {
      this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(x => x !== id);
    } else {
      this.selectedRecipentDpItems.push(id);
    }
    return;
  }

  // Parent (main DP)
  const dpId = id;
  const dpObj = this.recipientDpList.find((d: any) => String(d.item_id) === dpId);

  if (this.selectedRecipentDpItems.includes(dpId)) {
    // Deselect → remove children too
    this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
      (x) => !String(x).startsWith(`${dpId}_`) && String(x) !== dpId
    );
    if (dpObj) dpObj.NestedArray = [];
    this.flattenDropdownList();
    return;
  }

  // Select → add parent and load relatives
  this.selectedRecipentDpItems.push(dpId);

  if (!dpObj?.NestedArray?.length) {
    console.log('dpId',dpId)
    this.insiderService.getImmediateRelatives(dpId).subscribe({
      next: (res) => {
        const relatives = (res || [])
          .filter((r: any) => r.relativeemail)
          .map((r: any) => ({
            item_id: `${dpId}_${r.imr_id}`,
            item_text: r.relativeemail,
            isRelative: true
          }));
        if (dpObj) dpObj.NestedArray = relatives;
        this.flattenDropdownList();
      },
      error: (err) => console.error('Error loading relatives:', err),
    });
  }
}

noop(e: any) {
  e.originalEvent?.stopPropagation();
  e.originalEvent?.preventDefault();
}

onItemCheckboxClick(item: any, event: MouseEvent) {
  // ✅ stop PrimeNG from auto-handling click
  event.stopPropagation();
  event.preventDefault();

  const id = String(item.item_id);

  // Toggle manually
  if (this.selectedRecipentDpItems.includes(id)) {
    this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(x => x !== id);
  } else {
    this.selectedRecipentDpItems.push(id);
  }

  // ✅ If clicked on a parent (main recipient DP)
  if (!id.includes('_')) {
    const dpId = id;
    const dpObj = this.recipientDpList.find((d: any) => String(d.item_id) === dpId);

    // Fetch relatives if not already loaded
    if (!dpObj?.NestedArray?.length) {
      this.insiderService.getImmediateRelatives(dpId).subscribe({
        next: (res) => {
          const relatives = (res || [])
            .filter((r: any) => r.relativeemail)
            .map((r: any) => ({
              item_id: `${dpId}_${r.imr_id}`,
              item_text: r.relativeemail,
              isRelative: true
            }));

          if (dpObj) dpObj.NestedArray = relatives;

          // ✅ Refresh flattened data to show relatives
          this.flattenDropdownList();
        },
        error: (err) => console.error("Error loading relatives:", err),
      });
    }
  }

  console.log("✅ Selected Items:", this.selectedRecipentDpItems);
}

toggleCheckbox(item: any, event: MouseEvent) {
  event.stopPropagation();
  event.preventDefault();

  const id = String(item.item_id);
  const isSelected = this.selectedRecipentDpItems.includes(id);

  if (isSelected) {
    // Unselect current item
    this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(x => x !== id);
  } else {
    // Select current item
    this.selectedRecipentDpItems.push(id);
  }

  // ✅ If it's a parent mail
  if (!id.includes('_')) {
    const dpId = id;
    const dpObj = this.recipientDpList.find((d: any) => String(d.item_id) === dpId);

    if (!isSelected) {
      // If parent is being selected, fetch relatives (if not already)
      if (!dpObj?.NestedArray?.length) {
        this.insiderService.getImmediateRelatives(dpId).subscribe({
          next: (res) => {
            const relatives = (res || [])
              .filter((r: any) => r.relativeemail)
              .map((r: any) => ({
                item_id: `${dpId}_${r.imr_id}`,
                item_text: r.relativeemail,
                isRelative: true
              }));
            if (dpObj) dpObj.NestedArray = relatives;

            this.flattenDropdownList();

            // ✅ optional: auto-select all relatives too
            this.selectedRecipentDpItems.push(...relatives.map(r => r.item_id));
          },
          error: (err) => console.error('Error loading relatives:', err),
        });
      }
    } else {
      // If parent is being deselected → remove all its relatives too
      this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
        (x) => !String(x).startsWith(`${dpId}_`)
      );
      if (dpObj) dpObj.NestedArray = [];
      this.flattenDropdownList();
    }
  }

  // 🔍 for debugging
  console.log('Selected:', this.selectedRecipentDpItems);
}



togglePanel() {
  this.panelOpen = !this.panelOpen;
}

filteredRecipientDpList() {
  if (!this.searchText) return this.recipientDpList;
  const q = this.searchText.toLowerCase();
  return this.recipientDpList.filter(dp =>
    dp.item_text.toLowerCase().includes(q) ||
    (dp.NestedArray || []).some((r: any) => r.item_text.toLowerCase().includes(q))
  );
}

getItemTextById(id: string) {
  const p = this.recipientDpList.find(x => x.item_id === id);
  if (p) return p.item_text;
  for (const dp of this.recipientDpList) {
    const ch = (dp.NestedArray || []).find((r: any) => r.item_id === id);
    if (ch) return ch.item_text;
  }
  return id;
}

isSelected(itemId: any): boolean {
  return this.selectedRecipentDpItems.some((i) => i.item_id === itemId);
}

deselectById(event: MouseEvent, id: any) {
  event.stopPropagation();
  this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
    (i) => i.item_id !== id
  );
  this.updateRecipientForm();
}

loadRelatives(dp: any, event?: Event) {
  if (event) event.stopPropagation();
  if (dp.NestedArray && dp.NestedArray.length) return;
  this.insiderService.getImmediateRelatives(dp.item_id).subscribe({
    next: (res: any[]) => {
      const relatives = (res || []).filter(r => r.relativeemail).map(r => ({
        item_id: `${dp.item_id}_${r.imr_id}`,
        item_text: r.relativeemail
      }));
      dp.NestedArray = relatives;
    },
    error: () => { dp.NestedArray = []; }
  });
}

collapseRelatives(dp: any, event?: Event) {
  if (event) event.stopPropagation();
  // optional: remove selected children
  const dpId = dp.item_id;
  this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(id => !String(id).startsWith(`${dpId}_`));
  dp.NestedArray = [];
  if (this.twcCreateForm?.controls?.recipient) {
    this.twcCreateForm.controls.recipient.setValue(this.selectedRecipentDpItems);
  }
}

onParentToggle(dp: any, checked: boolean) {
  if (checked) {
    // Add parent
    if (!this.isSelected(dp.item_id)) {
      this.selectedRecipentDpItems.push({
        item_id: dp.item_id,
        item_text: dp.item_text,
      });
    }

    // Load relatives
    this.loadRelatives(dp);
  } else {
    // Remove parent + all its relatives
    this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
      (i) =>
        i.item_id !== dp.item_id &&
        !String(i.item_id).startsWith(`${dp.item_id}_`)
    );

    // collapse
    dp.NestedArray = [];
  }

  this.updateRecipientForm();
}

onChildToggle(dp: any, rel: any, checked: boolean) {
  if (checked) {
    if (!this.isSelected(rel.item_id)) {
      this.selectedRecipentDpItems.push({
        item_id: rel.item_id,
        item_text: rel.item_text,
      });
    }
  } else {
    this.selectedRecipentDpItems = this.selectedRecipentDpItems.filter(
      (i) => i.item_id !== rel.item_id
    );
  }

  this.updateRecipientForm();
}

isSelectedByEmail(email: string): boolean {
  return this.selectedRecipentDpItems.includes(email);
}

isChildOfParentEmail(email: string, parentId: any): boolean {
  // search the parent's NestedArray for an item_text equal to email
  const dpObj = this.recipientDpList.find((d: any) => d.item_id === parentId);
  if (!dpObj || !dpObj.NestedArray) return false;
  return dpObj.NestedArray.some((r: any) => r.item_text === email);
}

updateRecipientForm() {
  if (this.twcCreateForm?.controls?.recipient) {
    this.twcCreateForm.controls.recipient.setValue(this.selectedRecipentDpItems);
    this.twcCreateForm.controls.recipient.updateValueAndValidity();
  }
}

// Deselect via chip x button


// loadRelatives unchanged except ensure NestedArray item_text exists


}
